var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 35,
    viewBox: "0 0 15 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 0,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 5,
    height: 5,
    rx: 2.28571,
    fill: "#D9D8D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/Draggable.b07f2ef0245e1624647996f8fea868eb.svg";
export { ForwardRef as ReactComponent };